<template>
  <div class="login">
    <!-- 登陆图标 -->
    <div class="login-icon">
      <!-- <img src="../../../public/img/nxinlogo.png" alt=""> -->
    </div>
    <!-- 嵌套登陆窗 -->
    <iframe :src="BaseUrl" frameborder="0" class="login-iframe" scrolling="no" @load="unload($event)"></iframe>
  </div>
</template>

<script>
import Url from '../services/appsettings'
import qs from 'querystring'
export default {
  name: 'Login',
  data () {
    return {}
  },
  mounted () {},
  computed: {
    BaseUrl () {
      let query = {
        returnUrl: `${window.location.origin}/logincallback`,
        loginUrl: Url.casLogin
      }
      return `${Url.apiUrl}/api/account/login?${qs.stringify(query)}`
    }
  },
  methods: {
    unload (e) {
      console.log(e)
    }
  }
}
</script>

<style lang="stylus" scoped>
.login
  height 100%
  background-color #F2F2F2

  .login-icon
    position absolute
    top 4%
    left 50.5%
    margin-left -64px

    >img
      width 110px

  .login-iframe
    width 100%
    height 100%
</style>
